import { Controller } from '@hotwired/stimulus';

export default class BrandModelController extends Controller {
  static targets = ['brandSelect', 'modelSelect'];
  static values = {
    url: String,
  };

  onBrandChange(e) {
    if (this.brandSelectTarget.disabled) {
      return;
    }

    void this._updateModelsForSelectedBrands(e.detail.value.length ? e.detail.value : []);
  }

  async _updateModelsForSelectedBrands(selectedBrands) {
    if (!selectedBrands.length) {
      this._refreshModelSelect([]);
      return;
    }

    this._toggleModelSelectLoading(true);

    const params = new URLSearchParams();
    selectedBrands.forEach((brand) => params.append('brandIDs[]', brand.id));

    try {
      const response = await fetch(`${this.urlValue}?${params.toString()}`);
      if (!response.ok) {
        return;
      }
      const models = await response.json();

      this._refreshModelSelect(models);
    } catch (e) {
      // TODO show error message? toggle loading state?
      // this._toggleModelSelecLoading(false);
    }
  }

  _refreshModelSelect(models) {
    this.modelSelectTarget.dispatchEvent(
      new CustomEvent('update-choices', {
        detail: { choices: models },
        bubbles: false,
      })
    );
  }

  _toggleModelSelectLoading(isLoading) {
    this.modelSelectTarget.dispatchEvent(
      new CustomEvent('update-choices', {
        detail: { choices: isLoading ? null : [] },
        bubbles: false,
      })
    );
  }
}
